export const BASE_URL = "https://backend-api.esimafly.com/";
